

























































































import {Field} from "~/interfaces/application";
import Vue, {PropType} from "vue"

export default Vue.extend({
  name: "FormFieldDate",
  props: {
    item: {
      type: Object as PropType<Field>,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    fieldIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    blockIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    importantDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    value: "",
    menu: false,
    //
    mask: "##.##.####",
    showMenu: false,
    max: '2040-12-31',
    min: '1910-01-01',
    hideDetails: false,
    dirty: false,

  }),
  computed: {
    required() {
      return this.item.required
    },
    typeOfDocument() {
      //@ts-ignore
      return this.$store.getters['application/typeOfDocument']
    },
    stepNum() {
      return this.$store.getters['application/getStepNum']
    },
    validate: function () {
      // if (!this.item.value) {
      //   return [!this.item.required];
      // }

      if (!this.value) {
        return (!this.item.required ? [true] : ['Вы не ввели дату']);
      }

      // let value = this.item.value
      let value = this.value
      // TODO: ФОРМАТИРОВАНИЕ ДАТ И ВАЛИДАЦИЯ

      // if (! /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/.test(value as string) ) {
      if (!/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.([12][90][0-9][0-9])$/.test(value as string)) {
        return ['Некорректный формат даты'];
      }

      let dateArr = (value as string).split('.');
      const nowDate = new Date();
      const valDate = new Date(dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0]);
      // console.log('this.item.type', this.item.type)
      switch ((this.item as Field).type) {
        case "date_more":
          return (nowDate < valDate ? [true] : ["Дата должна быть больше текущей"]);
        case "date_less":
          if (this.item.code === "PREEMPTIVE_DATE") {
            const birthDate = new Date(this.$store.getters['application/getBirthDate']);
            // return (nowDate <= valDate
            //     ? ["Дата должна быть меньше текущей"]
            //     : birthDate >= valDate
            //         ? ["Дата не может быть меньше даты рождения"] : [true] );
            return (nowDate <= valDate
              ? ["Дата должна быть меньше текущей"]
              : [true] );
          } else {
            return (nowDate > valDate ? [true] : ["Дата должна быть меньше текущей"]);
          }
        case "birthday":
          const targetDate = new Date();
          targetDate.setFullYear(nowDate.getFullYear() - 8);
          return (valDate < targetDate ? [true] : ["Требуется указать возраст больше 8 лет"]);
        case "date_passport":
          const passportRfGuid = this.$store.getters['application/getRFDocuments'];
          let passportBlockGuid = '';
          const bDate = this.$store.getters['application/getBirthDate'];
          let targetValue = new Date(bDate);
          if (this.item.code === "DOCUMENT_BEFORE_DATE") {
            passportBlockGuid = this.$store.getters['application/getTypeOfPrevDocument'];
          } else {
            passportBlockGuid = this.$store.getters['application/typeOfDocument'];
          }
          let moreThen = targetValue;
          moreThen.setFullYear(targetValue.getFullYear() + 14);
          let result = passportRfGuid.includes(passportBlockGuid) ? (valDate > moreThen ? true : "Требуется возраст получения не менее 14 лет") : true;

          return [
            nowDate > valDate ? result : "Дата должна быть меньше текущей"
          ];
        default:
          return [true];
      }
      //return [true]
    },
    // formatDate: function() {
    //   if (!this.item.value) return null;
    //   const [year, month, day] = (this.item.value as string).split('-');
    //   return `${day}.${month}.${year}`;
    // },
    limitBirthDay: function () {
      let date = new Date();
      date.setFullYear(date.getFullYear() - 8);
      return date.toISOString().substr(0, 10);
    },
  },
  watch: {
    stepNum(){
      (this as any).setValue();
    }
  },
  methods: {
    isDirty(): boolean {
      return this.dirty || !!this.value
    },
    isValid(): boolean {
      try {
        this.validate.forEach((res: string|boolean) => {
          if (res && res !== true) {
            //@ts-ignore
            if (typeof res === 'string' && this.$refs?.inputElement?.validate) {
              //@ts-ignore
              this.$refs?.inputElement.validate(true)
            }
            throw "err";
          }
        })
      } catch (e) {
        return false;
      }
      return true;
    },
    setValue() {
        this.value = this.item.value;
    },
    change(value: string) {
      this.dirty = true
      // console.log(this.isValid())
      this.$store.dispatch('application/save', {path: this.path, value: value});
      this.$emit("changeValue", {value, fieldIndex: this.fieldIndex, blockIndex: this.blockIndex})
    },
    datePickerChangeHandler(event: any) {
      //console.log('event', event)
      this.change(new Date(event).toLocaleDateString())
      // this.$emit('input', new Date(event).toLocaleDateString())
      this.showMenu = false
    },
  },
  created() {
    (this as any).setValue();
  },
  mounted() {
    (this as any).setValue();
  },
})

